import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../Auth"
import { Outlet } from "react-router"

export default function Layout() {
	return (
		<ForbidUnlessAuthorized permission={PERMISSIONS.MANAGE_ROLES}>
			<Outlet />
		</ForbidUnlessAuthorized>
	)
}
